var _g, _g2, _g3, _g4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgOperations = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5101",
    "data-name": "Group 5101",
    width: 35.252,
    height: 39.898,
    viewBox: "0 0 35.252 39.898",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5097",
    "data-name": "Group 5097",
    transform: "translate(5.247 7.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M33,17.113l-.571,2.581a9.329,9.329,0,0,0-1.358.56l-2.231-1.42a.571.571,0,0,0-.708.078l-2.758,2.763a.569.569,0,0,0-.077.708l1.419,2.226a9.325,9.325,0,0,0-.56,1.358l-2.581.571a.57.57,0,0,0-.446.556V31a.57.57,0,0,0,.446.556l2.581.571a9.325,9.325,0,0,0,.56,1.357L25.3,35.711a.57.57,0,0,0,.077.708l2.758,2.762a.569.569,0,0,0,.708.078l2.231-1.42a9.316,9.316,0,0,0,1.358.56L33,40.982a.57.57,0,0,0,.556.447h3.9a.57.57,0,0,0,.556-.445l.576-2.583a9.315,9.315,0,0,0,1.353-.559l2.231,1.42a.568.568,0,0,0,.708-.078l2.758-2.762a.57.57,0,0,0,.078-.708L44.3,33.48a9.359,9.359,0,0,0,.559-1.353l2.582-.571A.57.57,0,0,0,47.888,31V27.094a.57.57,0,0,0-.446-.556l-2.582-.571a9.363,9.363,0,0,0-.559-1.353l1.419-2.231a.569.569,0,0,0-.078-.708l-2.758-2.763a.57.57,0,0,0-.708-.078l-2.231,1.42a9.315,9.315,0,0,0-1.353-.559l-.576-2.582a.57.57,0,0,0-.556-.445h-3.9A.57.57,0,0,0,33,17.113Zm4,.692.549,2.461a.569.569,0,0,0,.4.424,8.2,8.2,0,0,1,1.742.72.574.574,0,0,0,.582-.018L42.4,20.04l2.113,2.117-1.352,2.125a.57.57,0,0,0-.018.582,8.218,8.218,0,0,1,.72,1.742.57.57,0,0,0,.425.4l2.461.544v2.992l-2.461.544a.57.57,0,0,0-.425.4,8.2,8.2,0,0,1-.72,1.742.57.57,0,0,0,.018.582l1.352,2.126L42.4,38.054,40.276,36.7a.573.573,0,0,0-.582-.018,8.207,8.207,0,0,1-1.742.72.569.569,0,0,0-.4.424L37,40.289H34.015l-.544-2.461a.57.57,0,0,0-.4-.425,8.162,8.162,0,0,1-1.746-.72.572.572,0,0,0-.581.018l-2.125,1.352L26.5,35.938l1.352-2.122a.569.569,0,0,0,.018-.582,8.163,8.163,0,0,1-.72-1.745.57.57,0,0,0-.425-.4l-2.461-.544V27.551l2.461-.544a.571.571,0,0,0,.425-.4,8.167,8.167,0,0,1,.72-1.746.57.57,0,0,0-.018-.582L26.5,22.156l2.112-2.116,2.125,1.352a.572.572,0,0,0,.581.018,8.161,8.161,0,0,1,1.746-.72.57.57,0,0,0,.4-.425l.544-2.46H37Z",
    transform: "translate(-23.13 -16.666)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5098",
    "data-name": "Group 5098",
    transform: "translate(11.262 13.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M28.412,28.314a6.364,6.364,0,1,0,6.364-6.364A6.371,6.371,0,0,0,28.412,28.314Zm6.364-5.225a5.225,5.225,0,1,1-5.225,5.225A5.231,5.231,0,0,1,34.776,23.089Z",
    transform: "translate(-28.412 -21.95)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5099",
    "data-name": "Group 5099",
    transform: "translate(17.056 5.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M50.557,29.276a16.507,16.507,0,0,1-14.9,16.407l1.395-1.249a.57.57,0,0,0-.76-.849L33.7,45.909l0,0a.554.554,0,0,0,0,.842l0,0,2.593,2.323a.57.57,0,0,0,.76-.849l-1.564-1.4a17.617,17.617,0,0,0,9.1-31.7.57.57,0,0,0-.68.914A16.353,16.353,0,0,1,50.557,29.276Z",
    transform: "translate(-33.5 -15.015)",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5100",
    "data-name": "Group 5100",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M23.91,42.419a.569.569,0,0,0,.408-.966A16.484,16.484,0,0,1,34.577,13.562l-1.4,1.25a.57.57,0,0,0,.76.849l2.593-2.323a.57.57,0,0,0,0-.849l-2.593-2.323a.57.57,0,0,0-.76.849l1.564,1.4A17.614,17.614,0,0,0,23.5,42.246.567.567,0,0,0,23.91,42.419Z",
    transform: "translate(-18.522 -10.02)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOperations, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Operations.f3163d2e.svg";
export { ForwardRef as ReactComponent };